var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { findIndex } from "lodash";
import UserComponent, { UserViewButton } from "../User";
import UserProfilePopUp from "../UserProfilePopUp/UserProfilePopUp";
export var StyledUser = styled(UserComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .user_lastname {\n    ", "\n  }\n"], ["\n  .user_lastname {\n    ", "\n  }\n"])), function (props) { return (props.boldLastname ? "font-weight: bold;" : ""); });
var UserList = /** @class */ (function (_super) {
    __extends(UserList, _super);
    function UserList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userPopup = React.createRef();
        _this.state = {
            selectedUser: null
        };
        _this.getUserTeams = function (user) {
            return _this.props.teams
                .map(function (team) {
                var _a;
                if ((_a = user.teamIds) === null || _a === void 0 ? void 0 : _a.includes(team.uuid)) {
                    return team.public_name;
                }
                return null;
            })
                .filter(function (t) { return !!t; })
                .join(", ");
        };
        _this.action = function (user) {
            return React.createElement(UserViewButton, { user: user, onButtonClick: _this.openModal });
        };
        _this.openModal = function (user) {
            _this.setState({ selectedUser: user }, function () {
                _this.userPopup.current.show();
            });
        };
        return _this;
    }
    UserList.prototype.render = function () {
        var _this = this;
        var _a = this.props, employees = _a.employees, selectedEmployees = _a.selectedEmployees, onToggle = _a.onToggle, variables = _a.variables, onUpdate = _a.onUpdate, teams = _a.teams;
        var selectedUser = this.state.selectedUser;
        return (React.createElement("div", null,
            employees.map(function (user) { return (React.createElement(StyledUser, { key: user.uuid, user: user, rowData: _this.getUserTeams(user), boldLastname: false, onToggle: onToggle, checked: findIndex(selectedEmployees, function (test) { return test.uuid === user.uuid; }) > -1, action: _this.action(user) })); }),
            selectedUser && (React.createElement(UserProfilePopUp, { ref: this.userPopup, variables: variables, user: selectedUser, teams: teams, onUpdate: onUpdate }))));
    };
    UserList.defaultProps = {
        className: null
    };
    return UserList;
}(Component));
export { UserList };
export default UserList;
var templateObject_1;
